import React, { useContext, useState, useEffect } from 'react';
import { Tooltip } from 'antd';
import ValueContext from './Context';

export default function QuadChanger() {
  const { quadro, changeQuadro, version, getText, locale } = useContext(ValueContext);
  const [showTip, setshowTip] = useState(false);
  const [text, settext] = useState(getText());

  function handleQuadChange(e) {
    if (e.target.value === 'duo') {
      changeQuadro(false);
    } else {
      changeQuadro(true);
    }
  }

  useEffect(() => {
    settext(getText());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  return (
    <>
      <span className='RadioButtonQuad1'>
        <input
          type='radio'
          id='quadChoice1'
          name='quad'
          value='duo'
          checked={!quadro}
          onChange={handleQuadChange}
        />
        <label className='RadioLabel' htmlFor='quadChoice1'>
          MultiControl II duo
        </label>
      </span>
      <Tooltip title={text.Menu.QuadroToolTip} visible={showTip}>
        <span
          className={version === '3.2' ? 'RadioButtonQuad2 RadioDisable' : 'RadioButtonQuad2'}
          onMouseEnter={() => {
            if (version === '3.2') setshowTip(true);
          }}
          onMouseLeave={() => setshowTip(false)}>
          <input
            type='radio'
            id='quadChoice2'
            name='quad'
            value='quad'
            checked={quadro}
            disabled={version === '3.2'}
            onChange={handleQuadChange}
          />
          <label className='RadioLabel' htmlFor='quadChoice2'>
            MultiControl II quadro
          </label>
        </span>
      </Tooltip>
    </>
  );
}
